// Core imports
import * as React from 'react';
import remove from 'lodash.remove';
import { emailValidation } from 'src/utils/inputValidation';
import claimsServiceInstance from 'src/services/claimStatus/claimStatusService';
// Components imports
import ChipsInput from 'src/components/common/ChipsInput';
import Button from 'src/components/common/Button';
// import EmailInvoiceCard from '../EmailInvoiceCard';

// Models imports

// Style and misc imports
import './EmailClaimsModal.scss';
import Alert from 'src/components/common/Alert';
import ClaimStatusModel from 'src/model/ClaimStatus.model';
import EmailClaimCard from '../EmailClaimCard';
import { currencyFormatter } from 'src/utils/currencyFormatter';

class EmailClaimsModal extends React.Component<
  IEmailClaimsModalProps,
  IEmailClaimsModalState
> {
  constructor(props: any) {
    super(props);

    // console.log(props);

    // console.log(props.selectedClaims)
    this.state = {
      emailAddresses: [],
      emailError: false,
      sendEmailSuccessful: false,
      sendEmailError: false,
      cCSPDFErrMsg: this.props.csPDFErrMsg ? true : false
    };
  }

  /* 
    setEmailAddresses
   */
  private setEmailAddresses = (address: string) => {
    const { emailAddresses } = this.state;
    if (emailValidation(address)) {
      this.setState({
        emailAddresses: [address, ...emailAddresses],
        emailError: false
      });
    } else {
      this.setState({ emailError: true });
    }
  };

  /* 
    removeEmail
   */
  private removeEmail = (email: string) => {
    const newEmailAddresses = [...this.state.emailAddresses];
    remove(newEmailAddresses, (emailAddress: string) => email === emailAddress);
    this.setState({ emailAddresses: newEmailAddresses });
  };

  /* 
    getInvoicesToPrint
   */
  private getInvoicesToPrint = (): JSX.Element[] => {
    const invoicesToPrint: JSX.Element[] = [];
    const { allSelectedData } = this.props;
    allSelectedData.map((objClaim, index) => {
      invoicesToPrint.push(
        <EmailClaimCard
          key={index}
          claim={objClaim}
          removeClaimFromSelected={this.props.removeClaimsFromSelected}
        />
      );
    });
    return invoicesToPrint;
  };

  /* 
    prepareInvoicesNumbers
   */
  private prepareClaimsNumbers = () => {
    const { allSelectedData } = this.props;
    const claimNumbers: any[] = [];
    // console.log('prepareClaimNumbers>>this.props>>>', this.props);
    const selectedClaimsList: any[] = allSelectedData;
    selectedClaimsList.map(claims => {
      claimNumbers.push(`${claims.claimNo.toString()}`);
    });
    return claimNumbers;
  };

  private closeEmailAlert = () => {
    this.setState({ sendEmailError: false });
    this.setState({ cCSPDFErrMsg: false });
  };

  /*
  sendEmailService
  */

  private sendEmailService = () => {
    if (this.props.allSelectedData.length !== 0) {
      claimsServiceInstance
        .sendInvoiceByEmail(
          this.state.emailAddresses,
          this.prepareClaimsNumbers()
        )
        .then(response => {
          this.setState({ sendEmailSuccessful: true, sendEmailError: false });
        })
        .catch(error => {
          this.setState({ sendEmailSuccessful: false, sendEmailError: true });
        });
    }
  };

  /* 
    sendEmail
   */
  // private sendEmail = () => {
  //   const addresses: string[] = [];
  //   this.state.emailAddresses.map(mail => {
  //     const newMstr = mail.replace(/\s/g, '');
  //     addresses.push(newMstr);
  //   });
  //   this.setState({ emailAddresses: addresses }, () => this.sendEmailService());
  // };
  private sendEmail = () => {
    const addresses: string[] = [];
    const emailList: any[] = this.state.emailAddresses;
    emailList.map(mail => {
      const newMstr = mail.replace(/\s/g, '');
      addresses.push(newMstr);
    });
    this.setState({ emailAddresses: addresses }, () => this.sendEmailService());
  };
  /* 
    getDesktopButtons
   */
  private getDesktopButtons = () => {
    const { t, closeModal } = this.props;
    if (!this.props.isMobile) {
      if (!this.state.sendEmailSuccessful) {
        return (
          <React.Fragment>
            <Button
              buttonClass="secondary-custom-button send-invoices-button"
              textTransform="uppercase"
              label={t('common.cancel')}
              action={() => {
                closeModal();
              }}
              height="38px"
              width="158px"
            />
            <Button
              buttonClass="primary-custom-button send-invoices-button"
              textTransform="uppercase"
              label={t('common.sendEmail')}
              action={() => {
                this.sendEmail();
              }}
              height="38px"
              width="158px"
              disabled={this.state.emailAddresses.length === 0}
            />
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <Button
              buttonClass="primary-custom-button send-invoices-button"
              textTransform="uppercase"
              label={t('invoices.goBackToClaims')}
              action={() => {
                closeModal();
              }}
              height="38px"
              width="238px"
              disabled={this.state.emailAddresses.length === 0}
            />
          </React.Fragment>
        );
      }
    } else {
      return <React.Fragment />;
    }
  };

  /* 
    getMobileButtons
   */
  private getMobileButtons = () => {
    const { t, closeModal } = this.props;
    if (!this.state.sendEmailSuccessful) {
      return (
        <div>
          <Button
            buttonClass="primary-custom-button send-invoices-button-mobile"
            textTransform="uppercase"
            label={t('common.sendEmail')}
            action={() => {
              this.sendEmail();
            }}
            height="38px"
            width="100%"
            disabled={this.state.emailAddresses.length === 0}
          />
        </div>
      );
    } else {
      return (
        <Button
          buttonClass="primary-custom-button send-invoices-button-mobile"
          textTransform="uppercase"
          label={t('invoices.goBackToClaims')}
          action={() => {
            closeModal();
          }}
          height="38px"
          width="100%"
          disabled={this.state.emailAddresses.length === 0}
        />
      );
    }
  };

  /* 
    getEmailComponent
   */
  private getEmailComponent = () => {
    const { t } = this.props;
    const { emailError } = this.state;
    if (!this.state.sendEmailSuccessful) {
      return (
        <ChipsInput
          chips={this.state.emailAddresses}
          onAddChip={this.setEmailAddresses}
          containerClassname="email-container"
          inputClassname="email-input"
          chipClassName="chip"
          max={3}
          placeholder={t('formData.enterEmail_plural')}
          clearOnAdd={true}
          onRemoveChip={this.removeEmail}
          errorState={emailError}
        />
      );
    } else {
      return (
        <div className="email-address-container">
          {this.state.emailAddresses.map((email: any, index: any) => {
            return (
              <span key={index} className="email-address">
                {email}
              </span>
            );
          })}
        </div>
      );
    }
  };

  public render() {
    const { t, allSelectedData } = this.props;
    return (
      <div className="rp-invoice-email-modal">
        {this.props.allSelectedData && this.props.allSelectedData.length > 0 && (
          <>
            {this.state.cCSPDFErrMsg &&
              this.props.csPDFErrMsg &&
              this.props.csPDFErrMsg !== '' && (
                <Alert
                  styleClass="rp-email-error-alert"
                  type={'lwarning'}
                  icon={'rpds-warning'}
                  message={this.props.csPDFErrMsg}
                  handleCloseAlert={this.closeEmailAlert}
                />
              )}
            {this.state.sendEmailSuccessful ? (
              <div className="rp-invoice-email-modal--header-success">
                <span className="rpds-check-circle success-icon" />
                <div className="text">
                  <h1 className="title">
                    {allSelectedData.length > 1
                      ? t('claimStatus.claimsSent_plural')
                      : t('claimStatus.claimSent')}
                  </h1>
                  <span className="legend">
                    {allSelectedData.length > 1
                      ? t('claimStatus.sentClaimDetailsToEmail', {
                          count: allSelectedData.length
                        })
                      : t('claimStatus.sentClaimDetailsToEmail', {
                          count: allSelectedData.length
                        })}
                  </span>
                </div>
              </div>
            ) : (
              <React.Fragment>
                {this.state.sendEmailError && (
                  <Alert
                    styleClass="rp-email-error-alert"
                    type={'error'}
                    icon={'rpds-error'}
                    message={
                      "We couldn't send your claim details, check all the emails are correct or try again later."
                    }
                    handleCloseAlert={this.closeEmailAlert}
                  />
                )}
                <div className="rp-invoice-email-modal--header">
                  <h1 className="title">{t('formData.enterEmail_plural')}</h1>
                  <span className="legend">
                    {t('claimStatus.sentClaimDetailsToEmail', {
                      count: allSelectedData.length
                    })}
                  </span>
                </div>
              </React.Fragment>
            )}
            <div className="rp-invoice-email-modal--email-select">
              {!this.state.sendEmailSuccessful && (
                <span className="title">{t('formData.emailAddress')}</span>
              )}
              {this.getEmailComponent()}
              {!this.state.sendEmailSuccessful && (
                <span className="info">
                  Press the enter key to finalize email.
                </span>
              )}
            </div>
            <div className="rp-invoice-email-modal--desktop-buttons">
              {this.getDesktopButtons()}
            </div>
            {this.getMobileButtons()}
            <div
              className="rp-invoice-email-modal--invoices"
              style={{ overflow: 'auto' }}
            >
              <table
                id="tblExpt"
                className="tblExport"
                cellPadding={10}
                cellSpacing={10}
                style={{
                  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                  width: '100%',
                  border: '0px solid #000'
                }}
              >
                <thead>
                  <tr>
                    {this.props.csColumns
                      .filter(p => p.options.display === true)
                      .map((thr: any) => (
                        <th
                          style={{
                            textAlign: 'center',
                            backgroundColor: '#f2f2f2',
                            width: '25%'
                          }}
                        >
                          {thr.label}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {allSelectedData.map((row: any) => (
                    <>
                      <tr key={row.id}>
                        {this.props.csColumns
                          .filter(p => p.options.display === true)
                          .map((col: any) => (
                            <td
                              style={{ padding: '10px', textAlign: 'center' }}
                            >
                              {row[col.name]}
                            </td>
                          ))}
                      </tr>
                      <tr>
                        <td
                          colSpan={
                            this.props.csColumns.filter(
                              p => p.options.display === true
                            ).length
                          }
                          style={{
                            padding: '0px',
                            borderBottom: '1px solid #000'
                          }}
                        >
                          <table
                            style={{ border: '1px solid #000', width: '100%' }}
                          >
                            <thead>
                              <tr style={{ border: '1px solid #000' }}>
                                {this.props.csPartExpCols.map((col: any) => (
                                  <th
                                    style={{
                                      padding: '10px',
                                      textAlign: 'center',
                                      backgroundColor: '#f2f2f2'
                                    }}
                                  >
                                    {col.label}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {row.csPartDetails.map((cspart: any) => (
                                <tr key={cspart.id}>
                                  {this.props.csPartExpCols.map((col: any) => (
                                    <td
                                      style={{
                                        padding: '10px',
                                        textAlign: 'center'
                                      }}
                                    >
                                      {col.fVal && col.fVal === 'C' && (
                                        <>
                                          {currencyFormatter(cspart[col.value])}
                                        </>
                                      )}
                                      {!col.fVal && <>{cspart[col.value]}</>}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
        :{<></>}
      </div>
    );
  }
}

export default EmailClaimsModal;

interface IEmailClaimsModalProps {
  t: any;
  removeClaimsFromSelected(claim: ClaimStatusModel): void;
  closeModal(): void;
  allSelectedData: ClaimStatusModel[];
  isMobile?: boolean;
  csColumns: any[];
  csPartExpCols: any[];
  csPDFErrMsg: string;
}

interface IEmailClaimsModalState {
  emailAddresses: string[];
  emailError: boolean;
  sendEmailSuccessful: boolean;
  sendEmailError: boolean;
  cCSPDFErrMsg: boolean;
}
